export const AGAMI_INDOOR_CONFIG_SCHEMA = {
  type: 'array',
  items: {
    type: 'object',
    required: ['id', 'url', 'maxVolume', 'minVolume', 'position'],
    properties: {
      id: { type: 'string' },
      url: { type: 'string' },
      maxVolume: { type: 'number', minimum: 0 },
      minVolume: { type: 'number', minimum: 0 },
      position: {
        type: 'object',
        required: ['x', 'y'],
        properties: {
          x: { type: 'number' },
          y: { type: 'number' },
        },
        additionalProperties: false,
      },
    },
    additionalProperties: false,
  },
}
